import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'
import { Header, SubHeader } from 'shared/components/ui/Typography'
import PageHeader from '../../v3/PageHeader'
import { selectOnboardingLayoutVariant } from '../../selectors'
import Form from './Form'

const AcceptInvitePage = () => {
  const layoutVariant = useSelector(selectOnboardingLayoutVariant)

  if (layoutVariant === 3) {
    return (
      <>
        <PageHeader>
          <strong>Your team is waiting!</strong>
          <br />
          To get your set up in your account, we need a<br />few important bits
          of information.
        </PageHeader>
        <Form />
      </>
    )
  }

  return (
    <Fragment>
      <Header size="medium" as="h1">
        Your team is waiting!
      </Header>
      <SubHeader size="small" as="h2">
        To get you set up in your account, we need a few important bits of
        information.
      </SubHeader>
      <Form />
    </Fragment>
  )
}

export default AcceptInvitePage
